// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ConfirmButton_wrapper__30WVI","container":"ConfirmButton_container__1fkaq"};